import http from '../../../Utils/http';

const ResolveEntity = {
  name: 'signJetSyncResolve',
  state: {
    saving: false,
    actingEntityId: null,
    error: '',
    conflict: null,
    success: false,
  },
  reducers: {
    ResolveRequested(state, payload) {
      return { ...state, saving: true, actingEntityId: payload?.entityId ?? null, error: '', conflict: null, success: false };
    },
    ResolveSucceeded(state) {
      return { ...state, saving: false, actingEntityId: null, error: '', conflict: null, success: true };
    },
    ResolveFailed(state, payload) {
      return { ...state, saving: false, actingEntityId: null, error: payload, conflict: null, success: false };
    },
    ResolveConflict(state, payload) {
      return { ...state, saving: false, actingEntityId: null, error: '', conflict: payload, success: false };
    },
    ResolveReset(state) {
      return { ...state, saving: false, actingEntityId: null, error: '', conflict: null, success: false };
    },
  },
  effects: (dispatch) => ({
    async resolveEntity({ entityId, savvy_entity_id }) {
      try {
        this.ResolveRequested({ entityId });
        const response = await http.post(`savvy/signjet-sync/entities/${entityId}/resolve`, {
          savvy_entity_id,
        });
        this.ResolveSucceeded(response.data);
      } catch (err) {
        if (err?.response?.status === 409) {
          this.ResolveConflict(
            err.response.data || { message: 'This record is already linked to a different entity.' }
          );
          return;
        }
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.ResolveFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Resolve failed', open: true },
        });
      }
    },

    async resolveDrift({ entityId, action }) {
      try {
        this.ResolveRequested({ entityId });
        const response = await http.post(`savvy/signjet-sync/entities/${entityId}/resolve-drift`, {
          action,
        });
        this.ResolveSucceeded(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.ResolveFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to resolve name drift', open: true },
        });
      }
    },

    async resolveMismatch({ entityId, action }) {
      try {
        this.ResolveRequested({ entityId });
        const response = await http.post(`savvy/signjet-sync/entities/${entityId}/resolve-mismatch`, {
          action,
        });
        this.ResolveSucceeded(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.ResolveFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to resolve name mismatch', open: true },
        });
      }
    },

    async dismissDuplicateRisk({ entityId }) {
      try {
        this.ResolveRequested({ entityId });
        const response = await http.post(`savvy/signjet-sync/entities/${entityId}/dismiss-duplicate-risk`);
        this.ResolveSucceeded(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.ResolveFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to dismiss duplicate risk', open: true },
        });
      }
    },
  }),
};

export default ResolveEntity;
